import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';

@Component({
  selector: 'pps-error',
  templateUrl: "./error.component.html",
  styles: []
})
export class ErrorComponent implements OnInit {
  errorMessage = "";

  constructor(
    private _authService: AuthenticationService,
    private activedRoute: ActivatedRoute) { }

  ngOnInit(): void {
    this.activedRoute.queryParams.subscribe(params => {
      this.errorMessage = params.message;
    });
  }

  logout(){
    this._authService.logout();
  }
}
